import React from "react";
import style from "../Tooltip.module.css";
import { SIDEBAR_KEYS } from "ui/pages/TemplatePreview/constants";

export const TootltipData = {
  profile_picture: {
    id: "profile_picture",
    text: (
      <p>
        This image appears on your website and its pages. You can edit it from:{" "}
        <a
          className={style.link}
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = `${window.location.origin}/#/TemplatePreview?active_section=${SIDEBAR_KEYS.ABOUT_YOU}`;
          }}
          rel="noreferrer"
        >
          Manage webpage
        </a>{" "}
      </p>
    ),
  },
  profile_name: {
    id: "profile_name",
    text: (
      <p>
        This name appears on your website and all other places where you
        interact with your customers. You can edit it from:{" "}
        <a
          className={style.link}
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = `${window.location.origin}/#/TemplatePreview?active_section=${SIDEBAR_KEYS.ABOUT_YOU}`;
          }}
          rel="noreferrer"
        >
          Manage webpage
        </a>{" "}
      </p>
    ),
  },
  email_id: {
    id: "email_id",
    text: (
      <p>
        This is the email id where you will receive all the communications. All
        your communications will also go out to your customers with this email
        id.
      </p>
    ),
  },
  phone_number: {
    id: "phone_number",
    text: (
      <p>
        This is the phone number where you will receive all the communications.
        All your communications will also go out to your customers with this
        phone number.
      </p>
    ),
  },
};
